import { AWebsocketState } from "./AWebsocketState";
import { ConnectingState } from "./ConnectingState";

export class IdleState extends AWebsocketState {
  override connect(): void {
    console.log("IdleState: connecting...");
    this.client.openFreshSocket();
    this.client.setState(new ConnectingState(this.client));
  }
}
